import { Box, Button } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import AuthForm from "./AuthForm";
import { Link } from "react-router-dom";
const AuthBox = () => {

    const { isAuth } = useSelector(state => state.user)
    const [action, setAction] = useState()
    const [open, setOpen] = useState(false)
    
    if (isAuth) {
        return (
            <>
            <Button
                    variant="contained"
                    component={Link}
                    to={'/account'}
                >
                    Личный кабинет
                </Button>
            </>
        )
    }

    


    return (
        <>

            <AuthForm
                action={action}
                open={open}
                onClose={() => { setOpen(false); setAction(null) }}
            />

            <Box
                display="flex"
                gap={2}
            >
                <Button
                    variant="contained"
                    onClick={() => {
                        setAction('login')
                        setOpen(true)
                    }
                    }
                >
                    Вход
                </Button>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setAction('reg')
                        setOpen(true)
                    }
                    }
                >Регистрация
                </Button>
            </Box>
        </>
    )
}

export default AuthBox;